/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ViewProductsQueryVariables = {};
export type ViewProductsQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ViewProducts_viewer">;
    };
};
export type ViewProductsQuery = {
    readonly response: ViewProductsQueryResponse;
    readonly variables: ViewProductsQueryVariables;
};



/*
query ViewProductsQuery {
  viewer {
    ...ViewProducts_viewer
  }
}

fragment ViewProducts_viewer on Viewer {
  user {
    roles {
      name
      id
    }
    id
  }
  products {
    id
    title
    description
    dateAvailable
    imageUri
    image
    externalLink
    buttonText
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewProductsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ViewProducts_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ViewProductsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "products",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateAvailable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUri",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "buttonText",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "194715d205df134c615a7914f8c39e8b",
    "id": null,
    "metadata": {},
    "name": "ViewProductsQuery",
    "operationKind": "query",
    "text": "query ViewProductsQuery {\n  viewer {\n    ...ViewProducts_viewer\n  }\n}\n\nfragment ViewProducts_viewer on Viewer {\n  user {\n    roles {\n      name\n      id\n    }\n    id\n  }\n  products {\n    id\n    title\n    description\n    dateAvailable\n    imageUri\n    image\n    externalLink\n    buttonText\n  }\n}\n"
  }
};
})();
(node as any).hash = '12cd8b33d1c2d19e2e3c635cce9f73a8';
export default node;
